module.exports = __webpack_public_path__ + "static/media/bromollavapen.6eec3957.png";